import routerOptions0 from "/srv/sites/cryptoxchange/cryptoxchange-nuxt/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}